module.exports = __webpack_public_path__ + "img/personal8.dcad6718.jpg";